'use client';
import {useState} from 'react';
import Modal from '../Modal';
import Button from '../Button';
import WorkWithUsModalContent from './Content';
import {IAboutUsDictionary} from '@/dictionaries/pages/aboutUs/types';
import WorkWithUsModalSuccess from './SuccessModal';

type Props = {
  dict: IAboutUsDictionary;
};

export default function WorkWithUsModalTriggerWithContent({dict}: Props) {
  const [mainModalIsOpen, setMainModalIsOpen] = useState(false);
  const [successModalIsOpen, setSuccessModalIsOpen] = useState(false);
  const {applyNow} = dict.workWithUs;

  return (
    <>
      {successModalIsOpen && (
        <WorkWithUsModalSuccess
          dict={dict.workWithUs.modal.success}
          modalIsOpen={successModalIsOpen}
          setModalIsOpen={setSuccessModalIsOpen}
        />
      )}
      <Modal.Root open={mainModalIsOpen} onOpenChange={setMainModalIsOpen}>
        <Modal.Trigger>
          <div className="w-[calc(100%-1.25rem)] mx-[0.625rem] flex-[0_0_auto] desktop:ml-auto desktop:w-[calc(25%-1.875rem)]">
            <Button>{applyNow}</Button>
          </div>
        </Modal.Trigger>
        <Modal.Content onOpenChange={setMainModalIsOpen}>
          <WorkWithUsModalContent
            showSuccessModal={() => setSuccessModalIsOpen(true)}
            closeModal={() => setMainModalIsOpen(false)}
            dict={dict}
          />
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
